
export default function FilosofiaSection() {
  const pillars = [
    {
      icon: 'ri-leaf-line',
      title: 'Sostenibilità Radicale',
      desc: "Ogni progetto nasce dal rispetto profondo per l'ecosistema. Utilizziamo materiali naturali, locali e riciclabili per ridurre l'impronta ecologica.",
      image:
        'https://public.readdy.ai/ai/img_res/0f6767a831bf0ca23aec129755ea69b1.jpg',
    },
    {
      icon: 'ri-sun-line',
      title: 'Efficienza Bio-Climatica',
      desc: "Sistemi passivi di ventilazione, orientamento solare ottimale e isolamento termico naturale. L'edificio regola il proprio clima senza sprechi energetici.",
      image:
        'https://readdy.ai/api/search-image?query=modern%20building%20facade%20detail%20showing%20passive%20solar%20design%20elements%2C%20large%20south%20facing%20windows%20with%20natural%20wood%20brise%20soleil%20sun%20shading%2C%20green%20roof%20visible%20on%20top%2C%20cross%20ventilation%20openings%2C%20warm%20afternoon%20sunlight%20streaming%20through%2C%20sustainable%20bioclimatic%20architecture%20detail%2C%20professional%20architectural%20photography&width=600&height=400&seq=filosofia-bio-v2&orientation=landscape',
    },
    {
      icon: 'ri-plant-line',
      title: 'Simbiosi con la Natura',
      desc: "L'edificio non occupa lo spazio, ma vive con esso. Giardini verticali, tetti verdi e corridoi ecologici integrano la biodiversità nel tessuto urbano.",
      image:
        'https://readdy.ai/api/search-image?query=beautiful%20vertical%20garden%20on%20modern%20building%20wall%20with%20diverse%20Mediterranean%20plants%20and%20ferns%20growing%20lushly%2C%20integrated%20irrigation%20system%20visible%2C%20natural%20stone%20wall%20background%2C%20morning%20dew%20on%20leaves%2C%20biophilic%20architecture%20detail%2C%20professional%20nature%20and%20architecture%20photography%2C%20vibrant%20green%20tones&width=600&height=400&seq=filosofia-nature-v2&orientation=landscape',
    },
  ];

  return (
    <section id="filosofia" className="py-16 md:py-32 bg-[#f5f2ee]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="w-8 h-[1px] bg-[#6b8e7f]"></div>
            <span className="font-montserrat text-[10px] md:text-[11px] uppercase tracking-[3px] md:tracking-[4px] text-[#6b8e7f]">
              La Nostra Filosofia
            </span>
            <div className="w-8 h-[1px] bg-[#6b8e7f]"></div>
          </div>
          <h2 className="font-playfair text-[32px] md:text-[52px] font-bold text-[#2d3e40] leading-[1.15]">
            Tre Pilastri per un&apos;Architettura<br className="hidden md:block" /> che{' '}
            <em className="text-[#6b8e7f] not-italic">Respira</em>
          </h2>
          <p className="font-montserrat text-[14px] md:text-[15px] text-[#2d3e40]/60 mt-4 md:mt-6 max-w-[600px] mx-auto leading-[1.8]">
            La nostra visione si fonda su principi immutabili che guidano ogni decisione
            progettuale, dalla scelta dei materiali alla forma finale.
          </p>
        </div>

        {/* Pillars Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {pillars.map((pillar, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_40px_rgba(0,0,0,0.08)] transition-all duration-500 group"
            >
              <div className="relative w-full h-[200px] md:h-[240px] overflow-hidden">
                <img
                  src={pillar.image}
                  alt={pillar.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent"></div>
              </div>
              <div className="p-6 md:p-8 pt-4">
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-[#6b8e7f]/10 flex items-center justify-center mb-4 md:mb-5">
                  <i className={`${pillar.icon} text-[#6b8e7f] text-xl`}></i>
                </div>
                <h3 className="font-playfair text-[20px] md:text-[22px] font-bold text-[#2d3e40] mb-3">
                  {pillar.title}
                </h3>
                <p className="font-montserrat text-[13px] md:text-[14px] text-[#2d3e40]/65 leading-[1.8]">
                  {pillar.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
